module.exports = __webpack_public_path__ + "img/project-CO2Emissions.d1f3d1e4.jpg";